<template>
  <div>
    <div class="containerFull" style="min-height:600px">
      <div class="p-grid">
        <div class="p-col-12">
          <h2 style="border-bottom: 1px solid #cfcfcf;" class="p-pb-5 p-mt-6 titulo-admin p-ml-2">
            Listado de Cirugías
          </h2>
          <DataTable
            ref="dt"
            :value="cirugias"
            dataKey="id"
            :paginator="true"
            :rows="10"
            :filters="filters"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25]"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} cirugias"
            class="p-datatable-responsive-demo p-mt-5"
            style="margin-bottom:100px"
            :loading="loading"
          >
            <template #header>
              <div
                class="table-header"
                style="align-items: center;display: flex;"
              >
                <Button
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-info p-mr-3"
                  @click="openNew"
                  :disabled="loading"
                  v-tooltip.rigth="'Agregar nuevo'"
                  name="nuevo"
                />
                <span class="p-input-icon-left" style="margin-left: auto;">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters['global']"
                    placeholder="Buscar..."
                  />
                </span>
              </div>
            </template>
            <Column field="nombre" header="Nombre" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Nombre</span>
                {{ slotProps.data.nombre }}
              </template>
            </Column>
            <Column field="descripcion" header="Descripción" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Descripción</span>
                {{ slotProps.data.descripcion }}
              </template>
            </Column>
            <Column field="riesgo" header="Clasificación tarifaria" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Clasificación tarifaria</span>
                {{ slotProps.data.riesgo }}
              </template>
            </Column>
            <Column field="anestesia" header="anestesia" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">anestesia</span>
                {{ slotProps.data.anestesia == 0 ? "General" : "Local" }}
              </template>
            </Column>
            <Column :exportable="false">
              <template #body="slotProps">
                <span class="p-column-title">Acciones</span>
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success p-mr-2"
                  @click="editCirugia(slotProps.data)"
                  v-tooltip.top="'Editar'"
                  name="editar"
                />
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDeleteCirugia(slotProps.data)"
                  v-tooltip.top="'Eliminar'"
                  name="eliminar"
                />
              </template>
            </Column>
          </DataTable>

          <Dialog
            :closable="false"
            :visible="cirugiaDialog"
            :style="{ width: '450px' }"
            header="Detalles de la Cirugia"
            :modal="true"
            class="p-fluid"
            :contentStyle="{ overflow: 'visible' }"
          >
            <div class="p-grid">
              <div class="p-field p-col-12">
                <label for="nombre">Nombre</label>
                <InputText
                  id="nombre"
                  v-model.trim="cirugia.nombre"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !cirugia.nombre }"
                />
                <small class="p-invalid" v-if="submitted && !cirugia.nombre"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="descripcion">Descripción</label>
                <InputText
                  id="descripcion"
                  v-model.trim="cirugia.descripcion"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid': submitted && !cirugia.descripcion,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="submitted && !cirugia.descripcion"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="riesgo">Clasificación tarifaria</label>
                <Dropdown
                  id="riesgo"
                  v-model="cirugia.riesgo"
                  :options="riesgos"
                  placeholder="Seleccione una clasificación tarifaria"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid': submitted && !cirugia.riesgo,
                  }"
                />
                <small class="p-invalid" v-if="submitted && !cirugia.riesgo"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="anestesia">Anestesia</label>
                <div
                  v-for="(tipo_anestesia, index) in tipos_anestesia"
                  :key="index"
                  class="p-field-radiobutton"
                >
                  <RadioButton
                    :id="index"
                    name="anestesia"
                    :value="tipo_anestesia.value"
                    v-model="cirugia.anestesia"
                    autofocus
                  />
                  <label :for="index">{{ tipo_anestesia.name }}</label>
                </div>
              </div>
            </div>
            <template #footer>
              <Button
                label="Cancelar"
                icon="pi pi-times"
                class="p-button-text"
                @click="hideDialog"
                name="cancelar"
              />
              <Button
                label="Guardar"
                icon="pi pi-check"
                class="p-button-text"
                @click="saveCirugia"
                :disabled="loading"
                name="aceptar"
              />
            </template>
          </Dialog>
          <Dialog
            :visible="deleteCirugiaDialog"
            :style="{ width: '450px' }"
            header="Confirmación de eliminación"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="cirugia"
                >Esta seguro que desea eliminar la cirugia
                <b>{{ cirugia.nombre }}</b
                >?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteCirugiaDialog = false"
                name="cancelar"
              />
              <Button
                label="Si"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteCirugia"
                name="aceptar"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CirugiasService from "../service/cirugias.service";
export default {
  metaInfo: {
    title: 'Backoffice - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Backoffice - QualityCare',
        content: 'Administración del sitio web',
      },
    ],
  },
  data() {
    return {
      cirugiasService: null,
      filters: {},
      cirugia: {},
      cirugias: [],
      cirugiaDialog: false,
      deleteCirugiaDialog: false,
      submitted: false,
      loading: false,
      riesgos: [1,2,3, 4,5],
      tipos_anestesia: [
        { name: "General", value: 0 },
        { name: "Local", value: 1 },
      ],
    };
  },
  created() {
    this.cirugiasService = new CirugiasService();
  },
  mounted() {
    this.recuperarCirugias();
  },
  methods: {
    recuperarCirugias() {
      this.loading = true;
      this.cirugiasService
        .allCirugias()
        .then((result) => {
          if (result.data.data) {
            this.cirugias = [...result.data.data];
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al cargar las cirugías",
            life: 3000,
          });
          this.loading = false;
        });
    },
    openNew() {
      this.cirugia = { anestesia: 0 };
      this.submitted = false;
      this.cirugiaDialog = true;
    },
    hideDialog() {
      this.cirugiaDialog = false;
      this.submitted = false;
    },
    async saveCirugia() {
      this.submitted = true;
      if (
        this.cirugia.nombre &&
        this.cirugia.descripcion &&
        this.cirugia.riesgo
      ) {
        this.loading = true;
        if (this.cirugia.id) {
          //edicion de cirugia
          let idCirugiaEnEdicion = this.cirugia.id;
          let cirugiaEditada = {};
          await this.cirugiasService
            .editarCirugia(this.cirugia)
            .then((result) => {
              cirugiaEditada = result.data.data;
              this.$set(
                this.cirugias,
                this.findIndexById(idCirugiaEnEdicion),
                cirugiaEditada
              );
              this.$toast.add({
                severity: "success",
                summary: "Felicidades",
                detail: "Cirugia actualizado",
                life: 3000,
              });
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        } else {
          //nueva cirugia
          await this.cirugiasService
            .crearCirugia(this.cirugia)
            .then((result) => {
              this.cirugias.push(result.data.data);
              this.$toast.add({
                severity: "success",
                summary: "Felicidades",
                detail: "Cirugia creada",
                life: 3000,
              });
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
            });
        }
        this.cirugiaDialog = false;
        this.cirugia = {};
      }
    },
    editCirugia(cirugia) {
      this.cirugia = { ...cirugia };
      this.cirugiaDialog = true;
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.cirugias.length; i++) {
        if (this.cirugias[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    confirmDeleteCirugia(cirugia) {
      this.cirugia = cirugia;
      this.deleteCirugiaDialog = true;
    },
    deleteCirugia() {
      this.cirugiasService
        .eliminarCirugia({ id: this.cirugia.id })
        .then(() => {
          this.cirugias = this.cirugias.filter(
            (val) => val.id !== this.cirugia.id
          );
          this.deleteCirugiaDialog = false;
          this.cirugia = {};
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Cirugia eliminada",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tituloUsuarios {
  font-size: 28px;
  font-weight: 400;
  margin-right: 50px;
}
.muyLargo {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 40em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
        }
      }
    }
  }
}
</style>
